import { ComponentType } from 'react';

import { useAppSelector } from '../../../../../../store/hooks';
import { OuterFirmwareFiltersProps } from '../../models/outer-firmware-filters.props';

export const withFirmwareFilterValues = <
  TProps extends OuterFirmwareFiltersProps
>(
  WrappedComponent: ComponentType<TProps>
): ((props: Omit<TProps, 'firmwareSelectFilters'>) => JSX.Element) => {
  return (props: Omit<TProps, 'firmwareSelectFilters'>) => {
    const firmwareSelectFiltersState = useAppSelector(
      state => state.firmware.filters.header
    );

    return (
      <WrappedComponent
        {...(props as TProps)}
        firmwareSelectFilters={firmwareSelectFiltersState}
      />
    );
  };
};
